"use client";

import Script from "next/script";
import React from "react";

export default function CharacterFollower() {
  return (
    <Script
      src="/oneko.js"
      strategy="afterInteractive"
    />
  );
}
